import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const AboutSection = ({ id }) => {
  const [WSList, setWSList] = useState([]);

  const fetchData = async () => {
    try {
      const response = await corefetch(
        `WelcomeSection/GetAboutSectionList?displayesInID=${id}`
      );
      if (response && response.length > 0) {
        setWSList(response);
      } else {
        setWSList([]);
      }
    } catch (error) {
      setWSList([]);
      console.error("Error fetching list:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  if (!WSList || WSList.length === 0) {
    return null;
  }

  return (
    <>
      {WSList.map((item) => (
        <section
          className="services2 section-padding"
          data-scroll-index={1}
          key={item.id}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="services2 left">
                  <figure>
                    <img
                      src={`${ImageURL}${item.imagePath}`}
                      alt={item.title || "Image"}
                      className="img-fluid"
                    />
                  </figure>
                  <div className="caption padding-left">
                    <h4>
                      {/* <a href="../Events/Rental-Subpage.html"> */}
                      {item.title}
                      {/* </a> */}
                    </h4>
                    <p>{item.description}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}
    </>
  );
};

export default AboutSection;
